import React from 'react';
import Input from 'blocks/Input';
import HttpClient from 'services/HttpClient';
import validate from 'validate.js';
import {inject} from 'mobx-react';

const UPDATE_PASSWORD = '/api/v1/users/change_password';

const PASSWORD_CONDITIONS = {
  password: {
    length: {
      minimum: 6,
      tooShort: 'must be minimum 6 characters'
    }
  },
  password_confirmation: {
    equality: {
      attribute: 'password',
      message: 'needs to be the same as the new password specified.'
    }
  }
};
const EMPTY_BODY = { old_password: '', password: '', password_confirmation: ''};


@inject('alert')
export default class EditPassword extends React.Component {

  state = { body: EMPTY_BODY,
            errors: {}
  };

  handleChange = data => {
    let newState = _.assign({}, this.state.body, data);
    this.setState({ body: newState});
  };

  handleSubmit = e => {
    e.preventDefault();
    let errors = validate(this.state.body, PASSWORD_CONDITIONS);
    if(errors !== undefined){
      this.setState({errors: errors});
      return;
    }
    new HttpClient().put(UPDATE_PASSWORD, this.state.body).
      then( response => {
        this.props.alert.success('Password successfully changed');
        this.handleSuccess(response.body.data)}).
      catch(response => this.handleError())

  };
  handleSuccess = data => {
   this.setState({body: EMPTY_BODY, errors: {}})
  };

  handleError = () => {
    this.props.alert.error('Current Password is invalid');
    this.setState({errors: {old_password: ['Current Password is invalid']}});
  };

  render(){
    return (<form onSubmit={this.handleSubmit}>
      <div className="row">
        <div className="col">
          <Input name="old_password"
                 type="password"
                 value={this.state.body.old_password}
                 handleChange={this.handleChange}
                 placeholder="Current password"
                 error={this.state.errors.old_password}/>
        </div>
      </div>
      <div className="row">
        <div className="col">
          <Input name="password"
                 type="password"
                 value={this.state.body.password}
                 handleChange={this.handleChange}
                 placeholder="New Password"
                 error={this.state.errors.password}/>
        </div>
      </div>
      <div className="row">
        <div className="col">
          <Input name="password_confirmation"
                 type="password"
                 value={this.state.body.password_confirmation}
                 handleChange={this.handleChange}
                 placeholder="Password confirmation"
                 error={this.state.errors.password_confirmation}/>
        </div>
      </div>
      <div className="btn-holder">
        <button type="submit" className="btn grey-light bordered">CHANGE PASSWORD</button>
      </div>
    </form>);
  }
}



// WEBPACK FOOTER //
// ./src/components/my_profile/EditPassword.jsx